var _mask, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshot = function SvgScreenshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "screenshot_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.17 8 12 6h6l1.83 2H23c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M12 6V4.5h-.66l-.447.487zm-1.83 2v1.5h.66l.447-.487zm9.66 0-1.107 1.013.446.487h.661zM18 6l1.107-1.013-.446-.487H18zm-7.107-1.013-1.83 2 2.214 2.026 1.83-2zM10.17 6.5H7v3h3.17zM7 6.5A3.506 3.506 0 0 0 3.5 10h3c0-.272.228-.5.5-.5zM3.5 10v12h3V10zm0 12c0 1.928 1.572 3.5 3.5 3.5v-3a.506.506 0 0 1-.5-.5zM7 25.5h16v-3H7zm16 0c1.928 0 3.5-1.572 3.5-3.5h-3c0 .272-.228.5-.5.5zm3.5-3.5V10h-3v12zm0-12c0-1.928-1.572-3.5-3.5-3.5v3c.272 0 .5.228.5.5zM23 6.5h-3.17v3H23zm-2.063.487-1.83-2-2.214 2.026 1.83 2zM18 4.5h-6v3h6z",
    mask: "url(#screenshot_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18 16a3 3 0 0 0-3-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: 1.5,
    d: "M20.25 16a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 1.5,
    y: 1.5,
    stroke: "currentcolor",
    strokeDasharray: "3 4",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    rx: 1.5
  })));
};
export default SvgScreenshot;